//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/Features.js";
import "../no/Weld.js";
let d=[[[0,"AngularTolerance",1,0],[0,"BaseCornerCut",0,"Features.ShipDesign.CornerCutBuilder",0],[0,"DistanceTolerance",1,0],[1,"LocationOffset",0,"Expression",0],[1,"OrientationAngle",0,"Expression",0],[1,"ReinforceOffset",0,"Expression",0],[0,"ReinforcementCornerCut",0,"Features.ShipDesign.CornerCutBuilder",0],[0,"ReverseSplitDirection",1,0],[0,"SplitReinforcement",1,0],[1,"ToolCurve",0,"Section",0],[1,"ToolFacePlane",0,"SelectNXObject",0],[0,"ToolType",1,0],[0,"WeldCharacteristics",0,"Weld.CharacteristicsBuilder",0]],[[["selectedObjectTags"],"ConvertObjectsToAdd",{},1,0],[["selectedObjectTags"],"ConvertObjectsToRemove",{},1,0],[[],"Reset",{},0,0]],[]];
SPLM.Features.ShipDesign.SplitStandardPartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SplitStandardPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.SplitStandardPartBuilder.ToolTypes = Object.freeze({
    "FacePlane" : "FacePlane", "Curve" : "Curve"});

export default SPLM;